// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sIMQ5","left":"styles_left__LsSbh","desktopActions":"styles_desktopActions__17bfB","title":"styles_title__2nerJ"};